/**
 * Donor screening API — Phase 84 D-84-03.
 *
 * Two endpoints (both mounted under /api/leads/:leadId/screen-donors,
 * see backend/src/routes/donor-screening.js):
 *
 *   POST  /leads/:leadId/screen-donors         → triggers parallel scraper fan-out;
 *                                                with body `{platform}` (CARD-DEDUP D5 /
 *                                                ВОПРОС 8) the run is narrowed to that
 *                                                one platform, and `accounts[]` carries
 *                                                only it — the caller MERGES by platform
 *                                                rather than replacing its snapshot.
 *   GET   /leads/:leadId/screen-donors/latest  → returns latest snapshot per platform
 *
 * Both return the same envelope shape (D-84-04 — per-account only, no overall verdict):
 *   { ok: true, screenedAt: ISO|null, threshold: number, accounts: [...] }
 *
 * On expected service-level failure the envelope is `{ ok: false, code, error }`
 * — TanStack Query's `onError` fires when axios rejects (4xx/5xx status), so the
 * mutation/queryFn can branch on `error.data?.code` to render Russian copy.
 */
import apiClient from './client.js';

export async function screenDonors (leadId, platform) {
  const { data } = await apiClient.post(`/leads/${leadId}/screen-donors`, platform ? { platform } : {});
  return data;
}

export async function fetchLatestDonorScreening (leadId) {
  const { data } = await apiClient.get(`/leads/${leadId}/screen-donors/latest`);
  return data;
}
